import React from "react";
import { HStack } from "@commonsku/design-system";
import AutomationBreadcrumbs from "./AutomationBreadcrumbs";
import AutomationSaveBar from "./AutomationSaveBar";

export interface AutomationEditorHeaderProps {
  workflowName: string;
  isDirty: boolean;
  saving: boolean;
  error: string | null;
  onSave: () => void;
  onCancel: () => void;
}

/**
 * Top row of the automation editor page: breadcrumbs on the left,
 * save/cancel controls on the right.
 */
const AutomationEditorHeader = ({
  workflowName,
  isDirty,
  saving,
  error,
  onSave,
  onCancel,
}: AutomationEditorHeaderProps) => {
  return (
    <HStack justify="space-between" align="center" width="full">
      <AutomationBreadcrumbs workflowName={workflowName} />
      <AutomationSaveBar
        isDirty={isDirty}
        saving={saving}
        error={error}
        onSave={onSave}
        onCancel={onCancel}
      />
    </HStack>
  );
};

export default AutomationEditorHeader;
